export const exitModalText = (flowName: string) => ({
  title: 'Are you sure you want to exit?',
  subtitle: 'Your information will be lost.',
  primaryButton: `Exit ${flowName}`,
  secondaryButton: 'Keep going',
  textButton: 'Exit and share feedback'
});

export const exitCovidMessages = (flowName: string) => ({
  title: 'Are you sure you want to exit?',
  subtitle: 'Your information will be lost.',
  primaryButton: `Exit ${flowName}`,
  secondaryButton: 'Continue Screening'
});

export const exitCostEstimator = (flowName: string) => ({
  title: 'Are you sure you want to exit?',
  subtitle: 'Your information will be lost.',
  primaryButton: `Exit ${flowName}`,
  secondaryButton: `Continue ${flowName}`
});

export const exitEVisit = (flowName: string) => ({
  title: `You are exiting your ${flowName}.`,
  subtitle: `Do you wish to continue?`,
  primaryButton: `Yes, exit ${flowName}`,
  secondaryButton: `Continue my ${flowName}`,
  textButton: `Exit ${flowName} and give feedback`
});
